const isRecaptchaTimeoutError = (value) => {
  const message = String(value?.message || value?.reason?.message || value || '');
  const source = String(value?.filename || value?.reason?.filename || '');

  return (
    message.includes('reCAPTCHA Timeout') ||
    (message.includes('Timeout') && (source.includes('recaptcha') || source.includes('gstatic')))
  );
};

export const suppressRecaptchaTimeoutErrors = () => {
  window.addEventListener('error', (event) => {
    if (!isRecaptchaTimeoutError(event)) return;
    event.preventDefault();
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (!isRecaptchaTimeoutError(event)) return;
    event.preventDefault();
  });
};
